import { useMotionValue, useTransform } from 'framer-motion';
import { motion } from "../../Motion-polyfill";
import React from 'react';
import { Description, DivRelative, Image, Link, SubTitle, renderLineBreak } from '../../components/layouts';
import Visibility from '../../components/Visibility';
import { buildImageURL, getTrack } from '../../helpers';
import './style.scss';


const isWebp = document.querySelector('html').classList.contains('webpSupport');

const IMAGES = {
  d: {
    i1: isWebp ? buildImageURL('/s15-1.webp') : buildImageURL('/s15-1.jpg'),
    i2: isWebp ? buildImageURL('/s15-2.webp') : buildImageURL('/s15-2.jpg')
  },
  m: {
    i1: isWebp ? buildImageURL('/s15-1-m.webp') : buildImageURL('/s15-1-m.png'),
    i2: isWebp ? buildImageURL('/s15-2-m.webp') : buildImageURL('/s15-2-m.png')
  }
};

const track = getTrack({ block: 16 });

export function Section15({ mobile = false }) {
  const progress = useMotionValue(0);
  const handleUpdate = React.useCallback(
    (e, { calculations }) => {
      const { percentagePassed } = calculations;
      progress.set(percentagePassed);
    },
    [progress]
  );

  const ot = useTransform(progress, [0, 0.25], [1, 1]);
  const yt = useTransform(progress, [0, 0.25], [0, 0]);
  const o1 = useTransform(progress, [0, 0.75], [1, 0]);
  const o2 = useTransform(progress, [0, 0.75], [0, 1]);
  // const scale = useTransform(progress, [0, 0.125], [0.9, 1]);

  return (
    <Visibility fireOnMount offset={[-1000, 1000]} onUpdate={handleUpdate} className="page-section section-15 inverted" data-track={track}>
    {/*// <Visibility fireOnMount offset={[-0, 0]} onUpdate={handleUpdate} className="page-section section-15 inverted">*/}
      <div className="sticky-content">
        <DivRelative>
          <div className={`section-content ${mobile ? 'left' : 'center'}`}>
            <motion.div style={{ opacity: ot, y: yt }}>
              <SubTitle>拾起{renderLineBreak(mobile)}幸福欢乐的过往</SubTitle>
              <Description className={`${mobile ? 'left' : 'center'}`}>老旧、模糊照片，一键翻新，黑白人像照片，瞬间修复色彩。</Description>
              <Link bordered={false} href="https://shop.vivo.com.cn/product/10006689" text="购买我的 X60t Pro+" position={16} />
            </motion.div>
          </div>
          <motion.div className="photo-wrapper">
            <motion.div style={{ opacity: o1 }} className="photo-before">
              {!mobile && <Image src={IMAGES.d.i1} className="s15-i-1" />}
              {mobile && <Image src={IMAGES.m.i1} className="s15-i-1" />}
            </motion.div>
            <motion.div style={{ opacity: o2 }} className="photo-after">
              {!mobile && <Image src={IMAGES.d.i2} className="s15-i-2" />}
              {mobile && <Image src={IMAGES.m.i2} className="s15-i-2" />}
            </motion.div>
          </motion.div>
        </DivRelative>
      </div>
    </Visibility>
  );
}
